module.exports = __webpack_public_path__ + "static/img/021_1.e118332.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/021_1.jpg
// module id = C0QQ
// module chunks = 1